import { createAsyncThunk } from '@reduxjs/toolkit'
import { addUserRoles } from '../actions/organization'
import { getIDToken } from '../utils/AuthUtil'
import { BASE_URL } from '../config'
import { UserRole } from '../models/AccessControl'
import { setUserPolicies } from '../actions/auth'

export const fetchUserRolesAsync = createAsyncThunk(
  'roles/findAll',
  async (_, { dispatch }) => {
    return fetch(`${BASE_URL}/api/roles/findAll`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(addUserRoles(data))
      })
      .catch((error) =>
        console.error('Error during fetching user roles: ', error),
      )
  },
)

export const fetchAccessAttributesAsync = createAsyncThunk(
  'attributes/findAll',
  async (_, { dispatch }) => {
    return fetch(`${BASE_URL}/api/attributes/findAll`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) =>
        console.error('Error during fetching access attributes: ', error),
      )
  },
)

export const fetchAccessPoliciesAsync = createAsyncThunk(
  'policies/findAll',
  async (_, { dispatch }) => {
    return fetch(`${BASE_URL}/api/policies/findAll`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) =>
        console.error('Error during fetching role policies: ', error),
      )
  },
)

export const fetchRolePoliciesAsync = createAsyncThunk(
  'policies/findByRole',
  async (role: UserRole, { dispatch }) => {
    return fetch(`${BASE_URL}/api/policies/findAll`, {
      method: 'POST',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${await getIDToken()}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ role: role.name.toString() }),
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch(setUserPolicies(data))
      })
      .catch((error) =>
        console.error('Error during fetching role policies: ', error),
      )
  },
)
